import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import {
  BookingPayment,
  BookingPlayerType,
  TeeTimeBookingPlayer,
} from 'src/data/mygolf.data';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';

export interface BookingBuggy {
  buggySlot: number;
  driving: boolean;
  bookingPlayer?: TeeTimeBookingPlayer;
  pairingNo: number;
  walking: boolean;
  totalPlayers: number;
  maxAllowed: number;
}

@Component({
  selector: 'app-delete-room-modal',
  templateUrl: './delete-room-modal.component.html',
  styleUrls: ['./delete-room-modal.component.scss'],
})
export class DeleteRoomModalComponent implements OnInit {
  @Input() mode: string;
  @Input() msg: string;
  @Input() header: string;
  @Input() countryList: any;
  @Input() countryId: any;
  @Input() fromClub: any;
  @Input() _singleText: string;
  @Input() _msg: string;
  @Input() paymentData: any;
  @Input() bookingItemBill: any;
  @Input() bookingSlot: any;
  @Input() filteredClubMembership: any;
  @Input() subMsg: string;
  @Input() headerName: any;
  @Input() buggies: any;
  @Input() slot: any;
  @Input() bookingOptions: any;
  @Input() override: boolean;
  @Input() facilityBookingDetail: any;
  selectCountryDataStore: any;
  allCountry: any;
  estimationPriceList: Array<any>;
  constructor(
    private mdlCtrl: ModalController,
    private flightService: ClubFlightService
  ) {}

  ngOnInit() {
    if (this.countryId) this.selectCountryDataStore = this.countryId;
    this.allCountry = this.countryList;
    console.log(this.fromClub, '--fromClub--');
    console.log(this.facilityBookingDetail, 'facilityBookingDetail');
  }

  back() {
    this.mdlCtrl.dismiss();
  }

  confirm(data: string) {
    if (data) {
      this.mdlCtrl.dismiss(data);
    }
  }

  selectCountry(data: any) {
    if (!data) return false;
    this.selectCountryDataStore = data;
  }

  selectClub() {
    let selectCountry = this.countryList.find((a) => {
      return a.id === this.selectCountryDataStore;
    });
    console.log(selectCountry, '--selectCountry--');
    this.mdlCtrl.dismiss(selectCountry);
  }

  getFlagUrl(flagUrl: string) {
    if (flagUrl == null) return null;
    else {
      let flagIcon = flagUrl.split('/');
      return 'assets/img/flag/' + flagIcon[2];
    }
  }

  searchQuery: string = '';
  onSearchInput(ev) {
    console.log('Search Country Name', ev);
    let searchValue = ev || null;
    console.log(this.countryList, 'this.countryList');
    if (searchValue) {
      this.countryList = this.allCountry.filter((data) => {
        return data.name.toLowerCase().includes(searchValue?.toLowerCase());
      });
    } else {
      this.countryList = this.allCountry;
    }
  }

  isRedeemAmount(p: BookingPayment) {
    if (!p) return;
    if (p.paymentMethod.toLowerCase().includes('redeem')) return '(R)';
    else return;
  }

  getPlayerMembershipOther(playerId: number, attribute?: string) {
    if (!playerId) return;
    let _membershipNumber: string = '';
    let _membershipTypeName: string = '';
    if (this.filteredClubMembership)
      this.filteredClubMembership
        .filter((cm) => {
          return cm && cm.player && cm.player.id === playerId;
        })
        .map((cm) => {
          _membershipTypeName = cm.membershipType.typeName;
          _membershipNumber = '(' + cm.membershipNo + ')';
        });
    if (attribute === 'typeName') return _membershipTypeName;
    else return _membershipNumber;
  }

  selectBuggy(buggy: BookingBuggy) {
    this.mdlCtrl.dismiss({
      selected: true,
      buggy: buggy,
    });
  }

  getBuggySlot(buggy, i?) {}

  addTypePax(pax: number) {
    if (this.facilityBookingDetail?.facilityBookingDetail?.pax) {
      this.facilityBookingDetail.facilityBookingDetail.pax.pax += pax;
    }
  }

  addItemBalls(balls: number) {
    if (
      this.facilityBookingDetail?.facilityBookingDetail?.additionalBookingCount
    ) {
      this.facilityBookingDetail.facilityBookingDetail.additionalBookingCount.totalBalls +=
        balls * 10;
    }
  }
  facilityBookingDetailConfirm() {
    this.mdlCtrl.dismiss(this.facilityBookingDetail);
  }
}
